import { render, staticRenderFns } from "./sueldo_base.vue?vue&type=template&id=1008e2c8"
import script from "./sueldo_base.vue?vue&type=script&lang=js"
export * from "./sueldo_base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports